<template>
    <div class="relative rounded-lg shadow-sm bg-white"
         :class="{ 'border border-gray-200': ! plan.most_popular, 'border-2 border-primary-600': plan.most_popular }"
    >
        <div class="absolute inset-x-0 top-0 transform"
             v-if="plan.most_popular"
        >
            <div class="flex justify-center transform -translate-y-1/2">
                <span class="inline-flex rounded-full bg-primary-600 px-4 py-1 text-sm leading-5 font-semibold tracking-wider uppercase text-white">
                  Most popular
                </span>
            </div>
        </div>

        <div class="divide-y divide-gray-200 flex flex-col h-full">
            <div class="pt-8 pb-6 px-6 flex flex-col sm:h-76">
                <div class="flex-grow">
                    <h2 class="text-lg leading-6 font-medium text-gray-900">
                        {{ plan.name }}
                    </h2>
                    <p class="mt-4 text-sm leading-5 text-gray-500">
                        {{ plan.description }}
                    </p>
                </div>
                <p class="mt-8">
                    <span class="text-4xl leading-10 font-extrabold text-gray-900">£{{ price }}</span>
                    <span class="text-base leading-6 font-medium text-gray-500">/{{ period }}</span>
                </p>
                <a :href="route('customer.membership.billing', { plan: plan.id })"
                   class="mt-8 w-full text-center bg-primary-600 border border-primary-600 rounded-md py-2 text-sm leading-5 font-semibold text-white hover:bg-primary-500 focus:outline-none focus:shadow-outline-gray transition duration-150 ease-in-out"
                >
                    Buy {{ plan.name }}
                </a>
            </div>
            <div class="pt-6 pb-8 px-6 flex-grow">
                <h3 class="text-xs leading-4 font-medium text-gray-900 tracking-wide uppercase">What's included</h3>
                <ul class="mt-6 space-y-4">
                    <li class="flex space-x-3"
                        v-for="highlight in plan.highlights"
                    >
                        <svg class="flex-shrink-0 h-5 w-5 text-green-500" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                            <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd" />
                        </svg>
                        <span class="text-sm leading-5 text-gray-500">
                            {{ highlight.text }}
                        </span>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
	export default {
	    inject: ['pricingPlanState'],

		props: {
		    plan: {
		        type: Object,
                required: true,
            }
        },

        computed: {
		    price() {
		        return this.pricingPlanState.period === 'monthly' ?
                    this.plan.formatted_monthly_price : this.plan.formatted_yearly_price;
            },

            period() {
		        return this.pricingPlanState.period === 'monthly' ?
                    'mo' : 'yr';
            },
        }
	}
</script>
